<p-toast [key]="'global-top-center'" position="top-center" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'800ms'" [hideTransitionOptions]="'800ms'"></p-toast>
<router-outlet></router-outlet>
